import api from './api';

export interface LoginRequest {
  username: string;
  password: string;
}

export interface LoginResponse {
  token: string;
  expiresAt: string;
}

const TOKEN_KEY = 'admin_token';
const EXPIRES_AT_KEY = 'admin_token_expires_at';

class AuthService {
  /**
   * Login with username and password
   */
  async login(username: string, password: string): Promise<LoginResponse> {
    const response = await api.post<LoginResponse>('/auth/login', {
      username,
      password,
    });
    
    // Store token and expiration
    this.setToken(response.token);
    this.setExpiresAt(response.expiresAt);
    
    return response;
  }

  /**
   * Logout and clear stored token
   */
  logout(): void {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(EXPIRES_AT_KEY);
  }

  /**
   * Get the current token
   */
  getToken(): string | null {
    return localStorage.getItem(TOKEN_KEY);
  }

  /**
   * Check if user is authenticated
   */
  isAuthenticated(): boolean {
    const token = this.getToken();
    if (!token) {
      return false;
    }

    // Check if token is expired
    const expiresAt = localStorage.getItem(EXPIRES_AT_KEY);
    if (expiresAt) {
      const expirationDate = new Date(expiresAt);
      if (expirationDate < new Date()) {
        this.logout();
        return false;
      }
    }

    return true;
  }

  /**
   * Set the authentication token
   */
  private setToken(token: string): void {
    localStorage.setItem(TOKEN_KEY, token);
  }

  /**
   * Set the token expiration date
   */
  private setExpiresAt(expiresAt: string): void {
    localStorage.setItem(EXPIRES_AT_KEY, expiresAt);
  }
}

export default new AuthService();

